'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductForm = exports.ProductFormUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _Sagas = require('decorators/Sagas');

var _decorator = require('helpers/decorator');

var _SignupCardCta = require('./SignupCardCta');

var _product = require('../sagas/product.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductFormUnwrapped = exports.ProductFormUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ProductFormUnwrapped, _PureComponent);

  function ProductFormUnwrapped() {
    (0, _classCallCheck3.default)(this, ProductFormUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (ProductFormUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ProductFormUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProductFormUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onMount(this.props.hiddenFields);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          copy = _props.copy,
          handleSubmit = _props.handleSubmit,
          isSubmitting = _props.submitting,
          hasSucceeded = _props.submitSucceeded;


      return _react2.default.createElement(
        'form',
        {
          id: _product.PRODUCT_FORM,
          method: 'post',
          noValidate: true,
          onSubmit: handleSubmit
        },
        _react2.default.createElement(_SignupCardCta.SignupCardCta, {
          copy: copy,
          formId: _product.PRODUCT_FORM,
          isSubmitting: isSubmitting,
          isDisabled: hasSucceeded
        })
      );
    }
  }]);
  return ProductFormUnwrapped;
}(_react.PureComponent);

ProductFormUnwrapped.propTypes = {
  copy: _propTypes2.default.node,
  handleSubmit: _propTypes2.default.func.isRequired,
  hiddenFields: _propTypes2.default.object,
  onMount: _propTypes2.default.func.isRequired,
  submitting: _propTypes2.default.bool,
  submitSucceeded: _propTypes2.default.bool
};

var formConfig = {
  enableReinitialize: true,
  form: _product.PRODUCT_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: _product.productFormAction,
  onSubmitSuccess: function onSubmitSuccess(result, dispatch, props) {
    return props.onSuccess(result);
  }
};

var ProductForm = exports.ProductForm = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _product.watchProductFormSagas }), (0, _reactRedux.connect)(null, { onMount: _product.initializeProductForm }), (0, _reduxForm.reduxForm)(formConfig), (0, _decorator.withName)('ProductForm'))(ProductFormUnwrapped);